<template>
  <span v-if="fmt"> at {{ fmt }}</span>
</template>
<script setup lang="ts">
import { reltime } from "../utils";
const props = defineProps<{
  time: Date | string | undefined;
}>();
const fmt = reltime(props.time);
</script>
